import getFindPeopleResultsAsEmailAddressStrings from './getFindPeopleResultsAsEmailAddressStrings';
import FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import localCacheTransactionCompleted from 'owa-controls-findpeople-feedback-manager/lib/actions/localCacheTransactionCompleted';
import personaTypeMap from 'owa-controls-findpeople-feedback-manager/lib/utils/PersonaTypeMap';

/**
 * Adds a local cache transaction complete feedback
 */
export default function addLocalCacheTransactionComplete(
    recipientWellViewState: FindControlViewState
) {
    if (recipientWellViewState.findResultSet && recipientWellViewState.findResultSet.length > 0) {
        let personaTypeList = [];
        recipientWellViewState.findResultSet.forEach(suggestion => {
            personaTypeList.push(personaTypeMap[suggestion.PersonaTypeString]);
        });
        localCacheTransactionCompleted(
            recipientWellViewState.findPeopleFeedbackManager,
            recipientWellViewState.queryString,
            getFindPeopleResultsAsEmailAddressStrings(recipientWellViewState.findResultSet),
            null,
            personaTypeList
        );
    }
}
